const TASK_START = "Task_Start";
const TASK_RESUME = "Task_Resume";

export function isTaskStartOrResumeSubType(subType) {
    return subType === TASK_START || subType === TASK_RESUME;
}

/**
 * Whether the current profile should receive Activity Queue treatment for Task Start/Resume.
 *
 * @param {object|null|undefined} messageData
 * @param {number|string|null|undefined} currentProfileId
 * @param {object|null|undefined} itemVersion
 */
export function isProfileRecipientOfTaskStartResumeActivityQueue(
    messageData,
    currentProfileId,
    itemVersion = null,
) {
    const currentId = Number(currentProfileId);
    if (!currentId) {
        return false;
    }

    const data = messageData ?? {};
    const recipientIds = new Set();

    const assignerId = Number(
        data.assigner_profile_id ?? data.user_profile_id_assigner ?? 0,
    );
    const assignedById = Number(
        data.assigned_by_profile_id ?? data.user_profile_id_assigned_by ?? 0,
    );

    if (assignerId > 0) {
        recipientIds.add(assignerId);
    }
    if (assignedById > 0) {
        recipientIds.add(assignedById);
    }

    if (recipientIds.size === 0 && itemVersion) {
        const fallbackAssigner = Number(
            itemVersion.user_profile_id_creator ?? 0,
        );
        if (fallbackAssigner > 0) {
            recipientIds.add(fallbackAssigner);
        }
    }

    return recipientIds.has(currentId);
}
